var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ModalPlugin',{attrs:{"videoIds":_vm.selectedVideos}}),_c('History'),_c('AnnotationMenu'),_c('VideoMenu'),_c('UserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }